import { genStyleHooks } from '../../theme/internal';
import type { AliasToken, GenerateStyle } from '../../theme/internal';
import { blue, gray } from '../../theme/themes/colorPalette';

// biome-ignore lint/suspicious/noEmptyInterface: ComponentToken need to be empty by default
export interface ComponentToken {}

export interface ToggleToken extends AliasToken {
  componentCls: string;
}

const genToggleStyle: GenerateStyle<ToggleToken> = (token) => {
  const { componentCls } = token;
  return {
    [componentCls]: {
      display: 'inline-flex',
      verticalAlign: 'middle',
      alignItems: 'center',
      width: 98,
      height: 40,
      padding: 4,
      gap: 4,
      borderRadius: 4,
      border: `1px solid ${gray[200]}`,
      backgroundColor: gray[0],
      cursor: 'pointer',
      userSelect: 'none',
      boxSizing: 'border-box',
      transition: 'background-color 0.2s',
      outline: 'none',

      '&-thumb': {
        flexShrink: 0,
        width: 32,
        alignSelf: 'stretch',
        borderRadius: 4,
        border: `1px solid ${gray[400]}`,
        backgroundColor: gray[0],

        '&-disabled': {
          backgroundColor: gray[100],
        },
      },

      '&-label': {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        fontWeight: 500,
        color: gray[900],
        lineHeight: '20px',

        '&-disabled': {
          color: gray[600],
        },
      },

      '&-checked': {
        backgroundColor: blue[200],
      },

      [`&-checked:not(${componentCls}-disabled) ${componentCls}-thumb`]: {
        borderColor: gray[900],
      },

      '&-disabled': {
        backgroundColor: gray[200],
        cursor: 'not-allowed',
      },
    },
  };
};

export const useToggleStyle = genStyleHooks(
  'Toggle',
  (token) => [genToggleStyle(token)],
  undefined,
  { resetFont: false },
);
